import React, { useEffect } from 'react';
import logo from '../assets/img/or-logo.png';

let Header = (props) => {

    useEffect(() => {
        const iconMenu = document.querySelector('.menu__icon');
        if (iconMenu) {
            const menuBody = document.querySelector('.nav');
            const headerMob = document.querySelector('.header');
            const tabs = document.querySelector('.tabs');
            const dropdown = document.querySelector('.dropdown');
            const filterIcon = document.querySelector('.filter__icon');
            const addicon = document.querySelector('.icon-add');

            const handleMenuClick = (e) => {
                document.body.classList.toggle('lock');
                iconMenu.classList.toggle('active');
                headerMob.classList.toggle('active__nav');
                menuBody.classList.toggle('active');
                tabs && tabs.classList.toggle('position-static');
                dropdown && dropdown.classList.toggle('position-static');
                filterIcon && filterIcon.classList.toggle('position-static');
                addicon && addicon.classList.toggle('position-static');
            };

            iconMenu.addEventListener('click', handleMenuClick);

            // Удаление обработчика при размонтировании компонента
            return () => {
                iconMenu.removeEventListener('click', handleMenuClick);
            };
        }
    }, []);

    return (
        <div className="header">
            <div className="container">
                <div className="header__login">
                    <div className="header__logo">
                        <img alt="Organo Republic" src={logo} />
                    </div>
                    <div className="menu__icon">
                        <span></span>
                    </div>
                    <div className="nav">
                        <nav className="nav__menu">
                        </nav>
                        <div className="header__buttons">
                            <input 
                                type="button" 
                                className="btn btn__border" 
                                value="Log In" 
                                // onClick={handleLogout} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
